import { HttpMethod, HttpModel } from '@/Shared/domain'
import { axiosFetch, createQueryString } from '@/Shared/infrastructure'
import { addNewTpv, getTpvsData } from '@/Shared/infrastructure/endpoints'
import { TpvModel, TpvsRepository } from '@/Store/domain'
import { TpvForm } from '@/Store/ui/hooks'

export function createApiTpvRepository(): TpvsRepository {
  return new ApiTpvRepository()
}

type ApiTpvModel = {
  hasMerchantHardDependency: boolean
  masterGroupAlias: string | null
  masterGroupId: number | null
  merchantId: number
  merchantName: string
  merchantParentId: number | null
  merchantParentName: string | null
  superMasterGroupAlias: string | null
  terminalCompleteMid: string
  terminalCreationDate: string
  terminalId: 1585747
  terminalMid: string
  terminalName: string
  terminalStatusCode: number
  terminalStatusName: string
  terminalSubMid: string | null
  terminalZipCode: string
}

export class ApiTpvRepository implements TpvsRepository {
  async GetTpvsData(merchantTargetId: number): Promise<HttpModel<TpvModel[]>> {
    const response = await axiosFetch(
      getTpvsData.concat(
        createQueryString({
          merchantTargetId: merchantTargetId.toString(),
        }),
      ),
      HttpMethod.GET,
      {},
    )

    if (!response.data) {
      return {
        data: [],
        meta: response.meta,
      }
    }

    return {
      data: response.data.map((item: ApiTpvModel) => ({
        terminalMid: item.terminalMid,
      })),
      meta: response.meta,
    }
  }

  async AddNewTpv(data: TpvForm): Promise<HttpModel<boolean>> {
    const response = await axiosFetch(addNewTpv, HttpMethod.POST, data)

    if (!response.data) {
      return {
        data: false,
        meta: response.meta,
      }
    }

    return {
      data: response.data,
      meta: response.meta,
    }
  }
}
